@if (address()?.status_id !== toggleStatus){
  <button (click)="setAddressStatus(toggleStatus)" class="table-btn">{{label()}}</button>
} @else {
  <button (click)="setAddressStatus(defaultStatus())" class="table-btn">{{toggledLabel()}}</button>
}
